<template>
  <div v-if="isLaunchApp">
    <div style="position: relative">
      <slot />
      <wx-open-launch-app
        id="launch-btn"
        class="wx-open-app-btn"
        :appid="currentAppid"
        :extinfo="currentAPPSchemaParams"
        @error="handleErrorFn"
        @launch="handleLaunchFn"
      >
        <script type="text/wxtag-template">

          <style>
            * {
                -webkit-tap-highlight-color: transparent !important;
            }
            * {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index:1;
            }
            </style>
            <div class="template"></div>
        </script>
      </wx-open-launch-app>
    </div>
  </div>
  <div v-else @click="clickButton">
    <slot />
  </div>
</template>

<script>
import { isWXBrowser, isWxWorkBrowser } from '@/utils/browser'
import { getRecommendCode } from '@/utils/cookies'

export default {
  props: {
    unitKey: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: {},
    },
    appendParam: {
      type: Object,
      default: null,
    }, //安卓 额外参数
  },
  data() {
    return {
      protocal: '', //指定协议头
      failUrl: '', //失败回调
      appidList: {
        skb: 'wx03b6971146b301a4',
        jbcgk: 'wx9b7eea7beb3961a4',
        gpjs: 'wxc3e6067de3a53c6a',
        xuandiao: 'wx987f2cc92121f3e7',
        jbcshangan: 'wxf99856ccd8854baa',
      },
    }
  },
  computed: {
    isLaunchApp() {
      let brandKey = this.getCurrentBrand.brandKey
      return (
        isWXBrowser() &&
        (brandKey === 'skb' ||
          brandKey === 'jbcgk' ||
          brandKey === 'gpjs' ||
          brandKey === 'xuandiao' ||
          brandKey === 'jbcshangan') &&
        !isWxWorkBrowser()
      )
    },
    currentAPPSchemaParams() {
      return JSON.stringify(this.getAPPSchemaParams(this.unitKey, this.options, this.appendParam))
    },
    currentAppid() {
      let appid = this.appidList[this.getCurrentBrand.brandKey]
      return appid || this.appidList.skb
    },
  },
  mounted() {
    this.protocal = this.$brandConfig.getCurrentBrandSchemaParam.protocal
    this.failUrl = this.$brandConfig.getCurrentBrandSchemaParam.failUrl
    console.log(this.currentAPPSchemaParams)

    var btn = document.getElementById('launch-btn')
    var that = this
    try {
      btn.addEventListener('error', function (e) {
        console.log('监听launch-btn error')

        that.clickButton()
      })
    } catch (error) {}
  },
  methods: {
    // 唤醒APP
    openAPPSchema(schema) {
      this.$openSchema({
        protocal: this.protocal,
        schema: 'openUnit/schema?params=' + JSON.stringify(schema),
        failUrl: `https://a.app.qq.com/o/simple.jsp?pkgname=${this.failUrl}`,
      })
    },
    getAPPSchemaParams(unitKey, options, appendParam) {
      let brand = this.$brandConfig.getCurrentBrandSchemaParam.protocal,
        province = this.$route.query.province,
        appkey = brand + '.' + province
      const schemaParam = { brand, province }
      if (brand && province) {
        schemaParam.appkey = appkey
      }
      if (options) {
        Object.assign(schemaParam, options)
      }

      // 获取推荐码并添加到 param 中
      const recommendCode = getRecommendCode()

      if (Object.keys(recommendCode).length > 0) {
        schemaParam.recommend_code = recommendCode
      }

      const schema = {
        type: 'openUnit',
        option: {
          unitKey,
          param: schemaParam,
        },
      }

      if (appendParam) {
        schema.param = appendParam
      }
      return schema
    },

    // 执行打开app方法
    openApp(unitKey, options, appendParam) {
      this.openAPPSchema(this.getAPPSchemaParams(unitKey, options, appendParam))
    },
    // 点击按钮
    clickButton() {
      console.log('执行打开app方法')
      this.openApp(this.unitKey, this.options, this.appendParam)
    },
    handleErrorFn(e) {
      console.log('handleErrorFn:信息')
      console.log(e)
      console.log(e.detail)
    },
    handleLaunchFn(e) {
      console.log('handleLaunchFn:信息')
      console.log(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.wx-open-app-btn {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  overflow: hidden;
}
</style>
